import ReactDOM from 'react-dom';
import { ReactNode } from 'react';

interface PortalProps {
  to?: HTMLElement;
  children: ReactNode;
}

export const Portal = ({
  children,
  to: container = document.body,
}: PortalProps) => ReactDOM.createPortal(children, container);
